import isEmpty from 'lodash/isEmpty'
import { convertToQueryString, filterNonEmptyValues, serializeFiltersForQuery, parseQueryString, filterMapping } from '@/utils'

export default {
  computed: {
    filters() {
      return this.$store.getters['filters/getFilters']
    },
    activeNames() {
      const { filters } = this.$store.getters['filters/getCurrentPreset']
      return filters ? Object.keys(filters) : ''
    },
    filtersMeta() {
      return this.$store.getters['filters/getMeta']?.campaign
    },
    isFilterEmpty() {
      return isEmpty(this.filters)
    },
  },
  methods: {
    filterMapping,
    parseQueryString,
    filterNonEmptyValues,
    buildQueryParams() {
      const newQueries = convertToQueryString(this.filters)
      return newQueries
    },
    updateRouteWithFilters() {
      const newQueries = serializeFiltersForQuery(this.filters)
      if (this.$route.query.search) {
        newQueries.search = this.$route.query.search
      }
      this.$router.push({ path: this.$route.path, query: newQueries }).catch((err) => {
        if (err.name !== 'NavigationDuplicated' && !err.message.includes('Avoided redundant navigation to current location')) {
          throw err
        }
      })
    },
    clearFilterQueries() {
      const currentQueries = { ...this.$route.query }
      const filterKeys = Object.keys(this.filters)

      filterKeys.forEach((key) => {
        // Verifică dacă cheia există în query string-urile curente și o elimină
        if (Object.prototype.hasOwnProperty.call(currentQueries, key)) {
          delete currentQueries[key]
        }
        // Același lucru pentru subchei, dacă sunt utilizate
        if (Object.prototype.hasOwnProperty.call(currentQueries, `${key}--type`)) {
          delete currentQueries[`${key}--type`]
        }
      })

      // După eliminarea filtrelor, navighează la aceeași rută cu query-urile actualizate
      this.$router.push({ path: this.$route.path, query: currentQueries }).catch((err) => {
        if (err.name !== 'NavigationDuplicated' && !err.message.includes('Avoided redundant navigation to current location')) {
          console.error(err)
        }
      })

      this.$store.commit('filters/REMOVE_FILTERS')
      this.$store.commit('filters/SET_CURRENT_PRESET', false)
    },
  },
}
